var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,17H4v-2h6v2ZM24,6v12l-.29,.71-2,2-.71,.29H3l-.71-.29L.29,18.71l-.29-.71V6l.29-.71L2.29,3.29l.71-.29H21l.71,.29,2,2,.29,.71Zm-2,5H2v6.59l1.41,1.41H20.59l1.41-1.41v-6.59Zm0-4.59l-1.41-1.41H3.41l-1.41,1.41v1.59H22v-1.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditCard);
export default __webpack_public_path__ + "static/1765206080/media/icon-credit-card.b3dbd12c3b667718411462fd97cfd083.svg";
export { ForwardRef as ReactComponent };